import * as React from "react";

import { CustomerInformationQuery_Provider } from "./customer-information-query";

export const CustomerInformationProvider =
  CustomerInformationQuery_Provider;
